import { api } from "./api";
import { signOutModules } from "./modules";
import { clearOffline, offline, pendingOfflineChanges } from "./offline";

/** Ends the shared session and removes this account's saved mail from the device. */
export const signOut = async () => {
  const pending = await pendingOfflineChanges().catch(() => offline.get().pending);
  if (
    pending > 0 &&
    !window.confirm("Changes you made offline haven't been sent yet. Sign out and discard them?")
  )
    return;
  await signOutModules();
  await api
    .in(null)
    .post("/auth/logout")
    .catch(() => {});
  await clearOffline().catch(() => {});
  location.hash = "";
  location.reload();
};
